import React, { useState } from "react";
import node from "../assets/Lang/NodeJS.png";
import php from "../assets/Lang/PHP.png";
import java from "../assets/Lang/java.webp";
import mongo from "../assets/Lang/mongoDb.webp";
import python from "../assets/Lang/python.webp";
import redis from "../assets/Lang/redis.webp";
import sql from "../assets/Lang/sql.webp";
import tensorflow from "../assets/Lang/tensorflow.png";
import keras from "../assets/Lang/keras.png";
import jupyter from "../assets/Lang/jupyter.png";
import matlab from "../assets/Lang/Matlab.png";
import opencv from "../assets/Lang/opencv.png";
import bigml from "../assets/Lang/bigml.png";
import huggingFace from "../assets/Lang/hugging_face-icon.webp";
import scikitLearn from "../assets/Lang/scikit-learn.png";
import pytorch from "../assets/Lang/pytorch";
import dotnet from "../assets/Lang/dotnet.svg";
import { motion } from "framer-motion";
import tool from '../assets/tools.png'
import lovable from '../assets/Lang/lov.jpg'
import cursor from '../assets/Lang/cursot.jpg'
import windsurf from '../assets/Lang/windsurf.png'
import bolt from '../assets/Lang/bolt.webp'
import githubco from '../assets/Lang/githubco.png'
import codex from '../assets/Lang/codex.png'
import claude from '../assets/Lang/claude.png'
import grok from '../assets/Lang/grok.png'

import { InfiniteStack } from "./ui/infinite-stack";

// React.js
import reactLogo from "../assets/Lang/react.webp";

// Tailwind CSS
import tailwindLogo from "../assets/Lang/tailwind.png";

// TypeScript
import typescriptLogo from "../assets/Lang/ts.png";

// Next.js
import nextjsLogo from "../assets/Lang/nextjs.png";

// Firebase
import firebaseLogo from "../assets/Lang/firebase.png";

// Vercel
import vercelLogo from "../assets/Lang/vercel.svg";

// Git
import gitLogo from "../assets/Lang/git.png";

// Docker
import dockerLogo from "../assets/Lang/docker.png";

// React Query
import reactQueryLogo from "../assets/Lang/react query.png";

// Redux
import reduxLogo from "../assets/Lang/redux.png";

// Zustand
import zustandLogo from "../assets/Lang/zustand.jpg";

// Jest
import jestLogo from "../assets/Lang/jest.png";

// Bootstrap
import bootstrapLogo from "../assets/Lang/bootstrap.png";

// Babel
import babelLogo from "../assets/Lang/babel.jpg";

// Parcel
import parcelLogo from "../assets/Lang/parcel.png";

// Webpack
import webpackLogo from "../assets/Lang/webpack.png";

// Ant Design (AntD)
import antdLogo from "../assets/Lang/antd.png";

// Router
import routerLogo from "../assets/Lang/react-router.svg";

// Canva
import canvaLogo from "../assets/Lang/canva-icon.webp";

// Figma
import figmaLogo from "../assets/Lang/figma.webp";

// HTML
import htmlLogo from "../assets/Lang/html.webp";

// CSS
import cssLogo from "../assets/Lang/css.png";

const Stack = () => {
  // Grouped stacks
  const frontendStack = [
    { id: 'react', thumbnail: reactLogo, tooltip: 'React.js - A JavaScript library for building user interfaces' },
    { id: 'nextjs', thumbnail: nextjsLogo, tooltip: 'Next.js - A React framework for server-side rendering and static site generation' },
    { id: 'tailwind', thumbnail: tailwindLogo, tooltip: 'Tailwind CSS - A utility-first CSS framework for rapid UI development' },
    { id: 'typescript', thumbnail: typescriptLogo, tooltip: 'TypeScript - A superset of JavaScript that adds static typing' },
    { id: 'redux', thumbnail: reduxLogo, tooltip: 'Redux - A predictable state container for JavaScript apps' },
    { id: 'zustand', thumbnail: zustandLogo, tooltip: 'Zustand - A small, fast, and scalable state management tool for React' },
    { id: 'router', thumbnail: routerLogo, tooltip: 'React Router - A library for handling routing in React applications' },
    { id: 'bootstrap', thumbnail: bootstrapLogo, tooltip: 'Bootstrap - A front-end framework for developing responsive, mobile-first websites' },
    { id: 'antd', thumbnail: antdLogo, tooltip: 'Ant Design - A design system with a set of high-quality React components' },
    { id: 'html', thumbnail: htmlLogo, tooltip: 'HTML - The standard markup language for creating web pages' },
    { id: 'css', thumbnail: cssLogo, tooltip: 'CSS - A stylesheet language used for describing the presentation of a document written in HTML' },
    { id: 'canva', thumbnail: canvaLogo, tooltip: 'Canva - A graphic design platform for creating visual content' },
    { id: 'figma', thumbnail: figmaLogo, tooltip: 'Figma - A collaborative design tool for UI/UX design and prototyping' },
  ];

  const backendStack = [
    { id: 'node', thumbnail: node, tooltip: 'Node.js - JavaScript runtime for backend development' },
    { id: 'firebase', thumbnail: firebaseLogo, tooltip: 'Firebase - A platform for building web and mobile applications' },
    { id: 'docker', thumbnail: dockerLogo, tooltip: 'Docker - A platform for developing, shipping, and running applications in containers' },
    { id: 'git', thumbnail: gitLogo, tooltip: 'Git - A distributed version control system' },
    { id: 'vercel', thumbnail: vercelLogo, tooltip: 'Vercel - A platform for frontend frameworks and static sites' },
    { id: 'sql', thumbnail: sql, tooltip: 'SQL - A language for managing relational databases' },
    { id: 'mongo', thumbnail: mongo, tooltip: 'MongoDB - NoSQL database for modern apps' },
    { id: 'redis', thumbnail: redis, tooltip: 'Redis - In-memory data structure store' },
    { id: 'php', thumbnail: php, tooltip: 'PHP - A popular general-purpose scripting language' },


    { id: 'webpack', thumbnail: webpackLogo, tooltip: 'Webpack - A static module bundler for modern JavaScript applications' },
    { id: 'babel', thumbnail: babelLogo, tooltip: 'Babel - A JavaScript compiler that allows you to use the latest JavaScript features' },
    { id: 'parcel', thumbnail: parcelLogo, tooltip: 'Parcel - A fast, zero-config web application bundler' },
  ];

  const aiStack = [

    { id: 'lovable', thumbnail: lovable, tooltip: 'Hugging Face - AI community and model hub' },

    //        import cursor from '../assets/Lang/cursot.jpg'
    // import windsurf from '../assets/Lang/windsurf.png'
    // import bolt from '../assets/Lang/bolt.webp'
    // import githubco from '../assets/Lang/githubco.png'
    // import codex from '../assets/Lang/codex.png'
    // import claude from '../assets/Lang/claude.png'
    // import grok from '../assets/Lang/grok.png'
    { id: 'cursor', thumbnail: cursor, tooltip: 'Hugging Face - AI community and model hub' },
    { id: 'windsurf', thumbnail: windsurf, tooltip: 'Hugging Face - AI community and model hub' },
    { id: 'bolt', thumbnail: bolt, tooltip: 'Hugging Face - AI community and model hub' },
    { id: 'githubco', thumbnail: githubco, tooltip: 'Hugging Face - AI community and model hub' },
    { id: 'codex', thumbnail: codex, tooltip: 'Hugging Face - AI community and model hub' },
    { id: 'claude', thumbnail: claude, tooltip: 'Hugging Face - AI community and model hub' },
    { id: 'grok', thumbnail: grok, tooltip: 'Hugging Face - AI community and model hub' },

    { id: 'huggingface', thumbnail: huggingFace, tooltip: 'Hugging Face - AI community and model hub' },

  ];

  // Accordion state
  const [open, setOpen] = useState('frontend');

  const accordionData = [
    {
      key: 'frontend',
      title: 'Frontend',
      stack: frontendStack,
      direction: 'left',
      speed: 'slow',
    },
    {
      key: 'backend',
      title: 'Backend',
      stack: backendStack,
      direction: 'right',
      speed: 'fast',
    },
    {
      key: 'ai',
      title: 'AI tools',
      stack: aiStack,
      direction: 'left',
      speed: 'normal',
    },
  ];

  return (
    <section id='insights' className="relative  w-full py-10 lg:py-20 overflow-hidden flex flex-col md:flex-row justify-between items-start gap-4 lg:gap-6">
      {/* <div className=' w-full h-full'> */}
      <div
        className="absolute -top-10 -left-10 w-72 h-72 opacity-20 dark:opacity-10 text-muted-foreground"
        style={{
          backgroundImage: `
      linear-gradient(to right, currentColor 1.5px, transparent 1.5px),
      linear-gradient(to bottom, currentColor 1.5px, transparent 1.5px)
    `,
          backgroundSize: "60px 60px"
        }}
      />

      {/* </div> */}

      {/* Enhanced Background Glow with smooth animation */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gradient-to-br from-blue-400/20 via-purple-400/10 to-zinc-400/5 blur-[140px] rounded-full -z-10 pointer-events-none animate-pulse" style={{ animationDuration: '6s' }} />

      {/* Title Section - Sticky */}
      <div className="flex md:w-6/12  w-full flex-col items-start justify-start relative z-10 md:sticky  h-fit md:max-h-[calc(100vh-200px)]">
        <div className="space-y-2 animate-fade-in" style={{ animationDuration: '1s' }}>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <img src={tool} alt="" className="lg:w-32 w-24 mb-0" />
          </motion.div>

          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-bold     to-zinc-700 dark:from-zinc-100 dark:via-purple-300 dark:to-zinc-500 drop-shadow-lg">
            <span className="block !from-zinc-800 !to-zinc-400 !dark:from-zinc-100 !dark:to-zinc-500  animate-slide-up" style={{ animationDelay: '0.1s', animationDuration: '0.8s' }}>
              Things <i> I'm </i> good at
            </span>
            <span className="block mt-2 bg-clip-text text-transparent bg-gradient-to-r from-zinc-800 to-zinc-400 dark:from-zinc-100 dark:to-zinc-500 text-2xl lg:text-3xl font-semibold tracking-normal animate-slide-up" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
              ps - Tech Stack
            </span>
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-4">
          <div className="h-1 w-24 bg-gradient-to-r from-blue-500 via-purple-400 to-zinc-400 rounded-full" style={{ animation: 'gradient-shift 3s ease-in-out infinite' }} />
          <p className="text-left text-lg lg:text-xl font-light text-zinc-600 dark:text-zinc-400 max-w-md leading-relaxed tracking-wide animate-fade-in" style={{ animationDelay: '0.3s', animationDuration: '1s' }}>
            Using the right tools to build reliable web applications.
           Quick to  <b className="dark:text-white text-black">adapt</b> and  <b className="dark:text-white text-black">pick up</b> new technologies when required.
          </p>
        </div>
      </div>

      {/* Accordion Section with ultra-smooth transitions - Fixed Width */}
      <div className="flex  md:w-7/12 w-full flex-col gap-4 backdrop-blur-2xl  shadow-2xl relative animate-fade-in overflow-hidden" style={{ animationDelay: '0.4s', animationDuration: '1s', transitionProperty: 'all', transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)', transitionDuration: '600ms', contain: 'layout style paint' }}>
        {accordionData.map(({ key, title, stack, direction, speed }, index) => (
          <div
            key={key}
            className="overflow-hidden border-b border-zinc-200 dark:border-zinc-700 bg-white/80 dark:bg-zinc-900/60 shadow-md transition-all duration-700 transform hover:shadow-xl dark:hover:shadow-purple-900/40 animate-slide-up will-change-transform flex flex-col"
            style={{
              animationDelay: `${0.5 + index * 0.1}s`,
              animationDuration: '0.8s',
              transitionProperty: 'all',
              transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
              transitionDuration: '700ms',
              contain: 'layout style paint'
            }}
          >
            <button
              className={`w-full flex items-center justify-between px-6 py-4 text-lg font-semibold focus:outline-none transition-all duration-700 ease-in-out flex-shrink-0 ${open === key ? 'bg-gradient-to-r 00/30 shadow-inner' : 'bg-transparent '}`}
              onClick={() => setOpen(open === key ? '' : key)}
              aria-expanded={open === key}
            >
              <span className="text-zinc-800 dark:text-zinc-100 transition-all duration-700 font-semibold truncate">{title}</span>
              <svg
                className={`w-5 h-5 ml-2 text-zinc-700 dark:text-zinc-300 transition-all duration-700 ease-in-out flex-shrink-0`}
                style={{
                  transform: open === key ? 'rotate(180deg) scale(1.1)' : 'rotate(0deg) scale(1)',
                  transformOrigin: 'center',
                  transitionProperty: 'transform',
                  transitionDuration: '700ms',
                  transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)'
                }}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div
              className="overflow-hidden transition-all duration-700 ease-in-out"
              style={{
                maxHeight: open === key ? '500px' : '0px',
                opacity: open === key ? 1 : 0,
                transitionProperty: 'max-height, opacity',
                transitionDuration: '700ms',
                transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              <div className="px-4 py-3 bg-white/90 dark:bg-zinc-900/80 border-t border-zinc-100 dark:border-zinc-800 will-change-transform">
                <div className="flex justify-center h-[5.5rem] lg:h-[7rem] w-full items-center" style={{ animation: 'fadeInUp 1s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: open === key ? '0.15s' : '0s' }}>
                  <InfiniteStack
                    items={stack}
                    direction={direction}
                    speed={speed}
                    className="transition-all duration-700 opacity-100 hover:opacity-100"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Decorative corner accents with smooth animation */}
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: scaleY(0.9) translateY(-15px);
            max-height: 0;
          }
          to {
            opacity: 1;
            transform: scaleY(1) translateY(0);
            max-height: 500px;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes gradient-shift {
          0%, 100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }

        .animate-slide-up {
          animation: slide-up 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          opacity: 0;
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
          opacity: 0;
        }

        .will-change-transform {
          will-change: transform, opacity;
        }
      `}</style>
    </section>
  );
};

export default Stack;
